import React, { useMemo, useState, useEffect } from 'react';
import { camelizeKeys } from 'humps';
import sortBy from 'lodash/sortBy';

import { RouteEdit } from '../../components/Route/RouteEdit';
import { RouteElementType, getOrderGeo, isReturnIssueRoute } from '../../utils/utils';

const getSortedOrders = (orders, routeOrders) => {
  routeOrders.filter((element) => element.type === RouteElementType.ROUTE_ORDER).forEach((ro) => {
    const order = orders.find((o) => ro.order.id === o.id);

    if (order) {
      order.selected = true;
    } else {
      orders.push({ ...ro.order, selected: true });
    }
  });

  const filteredOrders = orders.reduce((arr, o) => {
    const geo = getOrderGeo(o);
    if (!geo) {
      toastr.error(__('routes.order_without_geo', { hashId: o.trackingId }), { timeOut: 10000 });
    } else {
      arr.push(o);
    }

    return arr;
  }, []);

  return sortBy(filteredOrders, 'selected');
};

export const RouteEditContainer = () => {
  // get data from window object
  const {
    // volumes,
    phones,
    cars,
    ramps,
    // route_car: routeCar
  } = window.routeData;

  const route = useMemo(() => camelizeKeys(window.routeData.route), [window.routeData.route]);
  const drivers = useMemo(() => camelizeKeys(window.routeData.drivers), [window.routeData.drivers]);
  const baseRouteOrders = useMemo(() => sortBy(
    camelizeKeys(window.routeData.route_orders).map((routeOrder) => ({
      ...routeOrder,
      via: routeOrder.via ? JSON.parse(routeOrder.via) : [],
    }))
  ),[window.routeData.route_orders]);
  const hasReturnPicking = isReturnIssueRoute(route);
  const statusWarehouseId = useMemo(() => window.routeData.status_warehouse_id, [window.routeData.status_warehouse_id]);
  const orderMissingServicesPrices = useMemo(() => camelizeKeys(window.routeData.order_missing_services_prices), [window.routeData.order_missing_services_prices]);

  // Initialize with inline orders (route orders only), then lazy-load all map orders
  const inlineOrders = useMemo(() => camelizeKeys(window.routeData.orders || []), [window.routeData.orders]);
  const initialOrders = useMemo(
    () => getSortedOrders(inlineOrders, baseRouteOrders),
    [inlineOrders, baseRouteOrders],
  );

  const [orders, setOrders] = useState(initialOrders);
  const [routeOrders, setRouteOrders] = useState(sortBy(baseRouteOrders, ['stage', 'ordering']));

  useEffect(() => {
    let cancelled = false;
    window.axios.get('/admin/routes/orders-for-map')
      .then(response => {
        if (cancelled) return;
        const allOrders = camelizeKeys(response.data);
        const sorted = getSortedOrders(allOrders, baseRouteOrders);
        setOrders(sorted);
      })
      .catch(err => console.warn('Failed to load map orders:', err));
    return () => { cancelled = true; };
  }, [baseRouteOrders]);

  const handleUpdateOrder = (id, data) => {
    setOrders((prevOrders) => prevOrders.map((order) => (order.id === id ? { ...order, ...data } : order)));
  };

  const handleUpdateRouteOrder = (id, data) => {
    setRouteOrders((prevRouteOrders) => {
      const updatedRouteOrders = prevRouteOrders.map((routeOrder) =>
        routeOrder.order?.id === id ? { ...routeOrder, ...data } : routeOrder
      );

      return sortBy(updatedRouteOrders, ['stage', 'ordering']);
    });
  };

  return (
    <RouteEdit
      orders={orders}
      routeOrders={routeOrders}
      // volumes={volumes}
      // routeCar={routeCar}
      route={route}
      phones={phones}
      drivers={drivers}
      cars={cars}
      ramps={ramps}
      hasReturnPicking={hasReturnPicking}
      statusWarehouseId={statusWarehouseId}
      orderMissingServicesPrices={orderMissingServicesPrices}
      onUpdateOrder={handleUpdateOrder}
      onUpdateRouteOrders={setRouteOrders}
      onUpdateRouteOrder={handleUpdateRouteOrder}
    />
  );
};
